export default {
  title: 'Wolt Drive onboarding',
  subtitle: 'Visible to onboarding managers only.',
  steps: {
    request: {
      title: '1. Request the venue from Wolt',
      description:
        "Copies this restaurant's row for the shared Wolt sheet. Paste it into column A of the next empty row, then let Wolt know in the joint Slack channel.",
    },
    activate: {
      title: '2. Verify and activate',
      description:
        'Enter the venue ID Wolt added to the sheet. It is checked with a test quote from Wolt before anything is saved.',
    },
  },
  fields: {
    venue_id: {
      label: 'Wolt venue ID',
      placeholder: 'e.g. 6736f9f5f9e2ab82f9150420',
      invalid: 'A Wolt venue ID is 24 characters long and uses only 0–9 and a–f.',
    },
    priority: {
      label: 'Provider priority',
      options: {
        wolt_primary: 'Wolt primary, keep current providers as fallback',
        wolt_only: 'Wolt only',
      },
    },
  },
  verification: {
    verified: 'Wolt confirmed this venue.',
    failed: 'Wolt could not confirm this venue.',
    wolt_reason: 'Wolt said: {{reason}}',
    unavailable_now: 'Wolt cannot deliver from this venue right now ({{reason}}). You can still save it.',
  },
  preview: {
    label: 'Provider order',
    none: 'none',
  },
  hints: {
    internal_delivery:
      'This restaurant delivers with its own drivers. Wolt is used once Delivery mode below is set to external drivers.',
    invalid_stored_id:
      'The stored venue ID {{venueId}} is not a valid Wolt venue ID, so Wolt is not used for this restaurant. Verify and save the correct one.',
  },
  buttons: {
    copy_details: 'Copy details',
    verify: 'Verify',
    save: 'Save',
  },
  confirm: {
    title: 'Activate Wolt Drive?',
    description: 'Saves venue ID {{venueId}} and changes the provider order to: {{providers}}.',
    unsaved_providers: 'Unsaved changes to the provider list below will be replaced.',
    ok: 'Save',
    cancel: 'Cancel',
  },
  toasts: {
    copied: 'Copied',
    copy_failed: 'Could not copy the details. Please try again.',
    saved: 'Wolt Drive is set up for this restaurant.',
    save_failed: 'Could not save. Please try again.',
  },
};
